import React, { useEffect, useContext, useState } from 'react';
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';



import Home from '../pages/Home';
import Home2 from '../pages/Home2';
import SingIn from '../pages/SingIn';
import SingUp from '../pages/SingUp';
import AuthLayout from './AuthLayout';
import MainLayout from './MainLayout';
import FirmList from '../pages/firms/FirmList';
import FirmDtl from '../pages/firms/FirmDtl';
import ClientRelationMain from '../pages/htl/clientrelations/ClientRelationMain';
import SalesOfficeMain from '../pages/htl/salesoffice/SalesOfficeMain'
import FrontDeskMain from '../pages/htl/frontdesk/FrontDeskMain'
import HotelBookingMain from '../pages/htl/hotelbooking/HotelBookingMain'
import InventoryMain from '../pages/htl/inventory/InventoryMain'
import HotelFinancialMain from '../pages/htl/hotelfinancial/HotelFinancialMain'
import HotelAdmMain from '../pages/htl/hoteladm/HotelAdmMain'

import HotelAccountingMain from '../pages/htl/hotelaccounting/HotelAccountingMain';
import FirmDefinitionsMain from '../pages/sterna/definitions/FirmDefinitionsMain'
import GnlDefinitionsMain from '../pages/sterna/definitions/GnlDefinitionsMain'
import FirmSubDtl from '../pages/firms/FirmSubDtl';
import FirmSubUsers from '../pages/firms/FirmSubUsers';
import FirmCreateWizard from '../pages/firms/CreateFirmWizard';
import AgencyListCoop from '../pages/htl/hoteladm/firm/AgencyListCoop';
import CustommerListCoop from '../pages/htl/hoteladm/firm/custommer/CustommerListCoop';

import AgencyDtlMainCoop from '../pages/htl/hoteladm/firm/AgencyDtlMainCoop'
import AgencyDtlSubCoop from '../pages/htl/hoteladm/firm/AgencyDtlSubCoop'
import AgencyCreateCoop from '../pages/htl/hoteladm/firm/AgencyCreateCoop';
import AgnAdmnMain from '../pages/agn/agnadm/AgnAdmMain';
import AgnReservationMain from '../pages/agn/agnreservation/AgnReservationMain';
import AgnSalesOfficeMain from '../pages/agn/agnsalesoffice/AgnSalesOfficeMain';
import AgnOperationMain from '../pages/agn/agnoperation/AgnOperationMain';
import AgnFinancialMain from '../pages/agn/agnfinancial/AgnFinancialMain';
import AgnAccountinMain from '../pages/agn/agnaccounting/AgnAccountinMain';
import HotelListCoop from '../pages/agn/agnadm/firm/HotelListCoop';
import HotelDtlMainCoop from '../pages/agn/agnadm/firm/HotelDtlMainCoop'
import HotelDtlSubCoop from '../pages/agn/agnadm/firm/HotelDtlSubCoop';
import OperatorListCoop from '../pages/agn/agnadm/firm/firmopr/OperatorListCoop';
import OperatorDtlMainCoop from '../pages/agn/agnadm/firm/firmopr/OperatorDtlMainCoop';
import OperatorDtlSubCoop from '../pages/agn/agnadm/firm/firmopr/OperatorDtlSubCoop';
import OprReservationMain from '../pages/opr/opreservation/OprReservationMain';
import OprFinancialMain from '../pages/opr/oprfinancial/OprFinancialMain';
import OprAccountinMain from '../pages/opr/opraccounting/OprAccountinMain';
import OprOperationMain from '../pages/opr/oproperation/OprOperationMain';
import OprSalesOfficeMain from '../pages/opr/oprsalesoffice/OprSalesOfficeMain';
import OprAdmnMain from '../pages/opr/opradm/OprAdmMain';
import OprAgencyListCoop from '../pages/opr/opradm/firm/OprAgencyListCoop';
import OprAgencyDtlMainCoop from '../pages/opr/opradm/firm/OprAgencyDtlMainCoop';
import OprAgencyDtlSubCoop from '../pages/opr/opradm/firm/OprAgencyDtlSubCoop';

import HtlRoomClassList from '../pages/htl/hoteladm/accommodation/roomclass/HtlRoomClassList';
import HtlRoomTypeList from '../pages/htl/hoteladm/accommodation/roomtype/HtlRoomTypeList';
import HtlHotelRoomTypeEdit from '../pages/htl/hoteladm/accommodation/roomtype/HtlHotelRoomTypeEdit';
import HtlAgnContactList from '../pages/htl/salesoffice/price/agncontract/HtlAgnContactList';
import HtlAgnContractEdit from '../pages/htl/salesoffice/price/agncontract/HtlAgnContractEdit';

import HtlSeasonList from '../pages/htl/hoteladm/hotel/seasons/HtlSeasonList';
import HtlCrtSalesDatesList from '../pages/htl/hoteladm/hotel/createsalesdates/HtlCrtSalesDatesList';
import RulesEng from '../pages/htl/salesoffice/price/agncontract/RulesEng';
import HtlOffersList from '../pages/htl/hoteladm/hotel/offers/HtlOffersList';
import HtlDynPriceGrpList from '../pages/htl/salesoffice/price/rules/dynpricegrp/HtlDynPriceGrpList';

import HtlAutoSalesPlantList from '../pages/htl/salesoffice/price/autosalesplan/HtlAutoSalesPlantList';
import HtlAutoSalesPlanEdit from '../pages/htl/salesoffice/price/autosalesplan/HtlAutoSalesPlanEdit';

import HtlSalesPlantList from '../pages/htl/salesoffice/price/salesplan/HtlSalesPlantList';
import HtlSalesPlanEdit from '../pages/htl/salesoffice/price/salesplan/HtlSalesPlanEdit';

import HtlBuildingList from '../pages/htl/hoteladm/accommodation/building/HtlBuildingList';
import HtlBuildingGroupList from '../pages/htl/hoteladm/accommodation/buildinggroup/HtlBuildingGroupList';
import HtlConfgRoomList from '../pages/htl/hoteladm/accommodation/configuringroom/HtlConfgRoomList';
import HtlSpaRoomList from '../pages/htl/hoteladm/spawellness/sparooms/HtlSpaRoomList';
import Sidebar from './Sidebarstr';
import HtlDprMainList from '../pages/htl/hoteladm/hotel/departments/HtlDprMainList';
import HtlWarehMainList from '../pages/htl/hoteladm/hotel/warehouses/HtlWarehMainList';
import HtlSalespMainList from '../pages/htl/hoteladm/hotel/salespoints/HtlSalespMainList';
import HtlUsespMainList from '../pages/htl/hoteladm/hotel/usespoints/HtlUsespMainList';
import HtlManifactCenterList from '../pages/htl/hoteladm/hotel/manifactoringcenter/HtlManifactCenterList';
import HtlCaseMainList from '../pages/htl/hoteladm/hotelaccounts/hotelcase/HtlCaseMainList';
import HtlCreditCardMainList from '../pages/htl/hoteladm/hotelaccounts/hotelcreditcard/HtlCreditCardMainList';

import HtlBankMainList from '../pages/htl/hoteladm/hotelaccounts/hotelbank/HtlBankMainList';

import HtlStokMainGrpList from '../pages/htl/hoteladm/productservices/stokmain/HtlStokMainGrpList';
import HtlProdStockCardList from '../pages/htl/hoteladm/productservices/prodstock/HtlProdStockCardList';
import HtlProdStockCardEdit from '../pages/htl/hoteladm/productservices/prodstock/HtlProdStockCardEdit';


import HtlProdAccomCardList from '../pages/htl/hoteladm/productservices/prodaccom/HtlProdAccomCardList';
import HtlProdAccomCardEdit from '../pages/htl/hoteladm/productservices/prodaccom/HtlProdAccomCardEdit';

import HtlResAboutList from '../pages/htl/hotelbooking/reservation/abouthotelres/HtlResAboutList';
import HtlResAboutDtlEdit from '../pages/htl/hotelbooking/reservation/abouthotelres/HtlResAboutDtlEdit';


import UsersList from '../pages/crm/users/usrmng/UsersList';
import CustList from '../pages/crm/custommers/cusmng/CustList';
import CustDtlEdit from '../pages/crm/custommers/cusmng/CustDtlEdit';
import CustDtlEditWeb from '../pages/crm/custommers/cusmng/CustDtlEditWeb';
import CusCallList from '../pages/crm/call/CustomerCallList';
import CustomerBookList from '../pages/crm/call/CustomerBookList';
import NewCustListEn from '../pages/crm/custommers/newcust/NewCustListEn';
import NewCustListAr from '../pages/crm/custommers/newcust/NewCustListAr';
import NewCustListDe from '../pages/crm/custommers/newcust/NewCustListDe';
import NewCustListRu from '../pages/crm/custommers/newcust/NewCustListRu';
import CustListMerge from '../pages/crm/custommers/cusmng/CustListMerge';
const Vari = () =>{

  
  return ( 
   
  
    <Router>
    <Routes>
      
      <Route path="/" element={<MainLayout/>}> 
        <Route path="/" element={<Home />} />   
        <Route path="Home2" element={<Home2 />} />  
        <Route path="/sterna/FirmList" element={<FirmList />} />  
        <Route path="FirmDtl/:firm_code" element={<FirmDtl />} /> 
        <Route path="/htl/client-relations/main" element={<ClientRelationMain />} /> 
        <Route path="/htl/sales-office/main" element={<SalesOfficeMain />} /> 
        <Route path="/htl/front-desk/main" element={<FrontDeskMain />} /> 
        <Route path="/htl/hotel-booking/main" element={<HotelBookingMain />} /> 
        <Route path="/htl/inventory/main" element={<InventoryMain />} /> 
        <Route path="/htl/hotel-financial/main" element={<HotelFinancialMain />} /> 
        <Route path="/htl/hotel-adm/main" element={<HotelAdmMain />} /> 
        <Route path="/htl/hotel-acc/main" element={<HotelAccountingMain />} /> 
        <Route path="/agn/agency-adm/main" element={<AgnAdmnMain />} /> 
        <Route path="/agn/agency-res/main" element={<AgnReservationMain />} /> 
        <Route path="/agn/agency-salesoff/main" element={<AgnSalesOfficeMain />} /> 
        <Route path="/agn/agency-operation/main" element={<AgnOperationMain />} /> 
        <Route path="/agn/agency-financial/main" element={<AgnFinancialMain />} /> 
        <Route path="/agn/agency-accounting/main" element={<AgnAccountinMain />} /> 
        <Route path="/opr/operator-res/main" element={<OprReservationMain />} /> 
        <Route path="/opr/operator-financial/main" element={<OprFinancialMain />} /> 
        <Route path="/opr/operator-accounting/main" element={<OprAccountinMain />} /> 
        <Route path="/opr/operator-operation/main" element={<OprOperationMain />} /> 
        <Route path="/opr/operator-salesoff/main" element={<OprSalesOfficeMain />} /> 
        <Route path="/opr/operator-adm/main" element={<OprAdmnMain />} /> 
        <Route path="/opr/operator-adm/firm/agency-list-coop" element={<OprAgencyListCoop />} /> 
        <Route path="/opr/operator-adm/firm/agencydtlmain-coop/:firm_main_code_n" element={<OprAgencyDtlMainCoop />} />
        <Route path="/opr/operator-adm/firm/agencydtlsub-coop/:firm_sub_code_n" element={<OprAgencyDtlSubCoop />} /> 
        <Route path="/htl/hotel-adm/firm/agency-list-coop" element={<AgencyListCoop />} /> 
        <Route path="/htl/hotel-adm/firm/custommer-list-coop" element={<CustommerListCoop />} /> 
        <Route path="/htl/hotel-adm/accomodation/room-class-list" element={<HtlRoomClassList />} /> 
        <Route path="/htl/hotel-adm/hotel/seasons-list" element={<HtlSeasonList />} /> 
        <Route path="/htl/hotel-adm/hotel/sales-date-list" element={<HtlCrtSalesDatesList />} /> 
        <Route path="/htl/hotel-adm/hotel/dprmain-list" element={<HtlDprMainList />} /> 
        <Route path="/htl/hotel-adm/hotel/warehmain-list" element={<HtlWarehMainList />} /> 
        <Route path="/htl/hotel-adm/hotel/salespmain-list" element={<HtlSalespMainList />} /> 
        <Route path="/htl/hotel-adm/hotel/usespmain-list" element={<HtlUsespMainList />} /> 
        <Route path="/htl/hotel-adm/hotel/manifactcent-list" element={<HtlManifactCenterList />} /> 

        <Route path="/htl/hotel-adm/hotelaccounts/case-list" element={<HtlCaseMainList />} /> 
        <Route path="/htl/hotel-adm/hotelaccounts/bank-list" element={<HtlBankMainList />} /> 
        <Route path="/htl/hotel-adm/hotelaccounts/creditcard-list" element={<HtlCreditCardMainList />} />

        <Route path="/htl/hotel-adm/productservices/stokmaingrp-list" element={<HtlStokMainGrpList />} /> 
        
        <Route path="/htl/hotel-adm/products/prodstccard-list" element={<HtlProdStockCardList />} /> 
        <Route path="/htl/hotel-adm/products/prodstccard-edit/:prod_code" element={<HtlProdStockCardEdit />} />
        
        <Route path="/htl/hotel-adm/products/prodaccomcard-list" element={<HtlProdAccomCardList />} /> 
        <Route path="/htl/hotel-adm/products/prodacmcard-edit/:prod_code" element={<HtlProdAccomCardEdit />} />
       
        
        <Route path="/htl/hotel-adm/accomodation/room-type-list" element={<HtlRoomTypeList />} /> 
        <Route path="/htl/hotel-adm/firm/accomodation/room-type/:r_type_code" element={<HtlHotelRoomTypeEdit />} />
        <Route path="/sterna/definitions/main" element={<FirmDefinitionsMain />} /> 
        <Route path="/sterna/definitions/gnl/main" element={<GnlDefinitionsMain />} /> 
        <Route path="FirmSubDtl/:firm_sub_code" element={<FirmSubDtl />} /> 
        <Route path="/htl/hotel-adm/firm/agencydtlmain-coop/:firm_main_code_n" element={<AgencyDtlMainCoop />} />
        <Route path="/agn/agency-adm/firm/operetordtlmain-coop/:firm_main_code_n" element={<OperatorDtlMainCoop />} />
        <Route path="/htl/hotel-adm/firm/agencydtlsub-coop/:firm_sub_code_n" element={<AgencyDtlSubCoop />} /> 
        <Route path="/agn/agency-adm/firm/operatordtlsub-coop/:firm_sub_code_n" element={<OperatorDtlSubCoop />} /> 
        <Route path="/agn/agency-adm/firm/hoteldtlmain-coop/:firm_main_code_n" element={<HotelDtlMainCoop />} />
        <Route path="/htl/agency-adm/firm/hoteldtlsub-coop/:firm_sub_code_n" element={<HotelDtlSubCoop />} /> 
        <Route path="/sterna/FirmSubUsers" element={<FirmSubUsers />} />  
        <Route path="/sterna/FirmCreateWizard" element={<FirmCreateWizard />} />  
        <Route path="/htl/hotel-adm/firm/agencycreate" element={<AgencyCreateCoop />} />  
        <Route path="/agn/agency-adm/firm/hotel-list-coop" element={<HotelListCoop />} /> 
        <Route path="/agn/agency-adm/firm/operator-list-coop" element={<OperatorListCoop />} /> 
        <Route path="/htl/sales/price/htlagncont-list" element={<HtlAgnContactList />} />
        <Route path="/htl/sales/price/htlagncontract/:id_seq" element={<HtlAgnContractEdit />} />
        <Route path="/htl/sales/price/rules" element={<RulesEng />} />
        <Route path="/htl/sales/offers/htlagnoffers-list" element={<HtlOffersList />} />
        <Route path="/htl/sales/rules/dynpricegrp/htl-dynprcgrp-list" element={<HtlDynPriceGrpList />} />
        
        <Route path="/htl/sales/price/htlautosalesplan-list" element={<HtlAutoSalesPlantList />} />
        <Route path="/htl/sales/price/htlautosalesplanedit/:id_seq" element={<HtlAutoSalesPlanEdit />} />
       
        <Route path="/htl/sales/price/htlsalesplan-list" element={<HtlSalesPlantList />} />
        <Route path="/htl/sales/price/htlsalesplanedit/:id_seq" element={<HtlSalesPlanEdit />} />
        
        

        <Route path="/htl/htl-adm/accomodation/htlbulding-list" element={<HtlBuildingList />} />
        <Route path="/htl/htl-adm/accomodation/htlbuldinggrp-list" element={<HtlBuildingGroupList />} />
        <Route path="/htl/htl-adm/accomodation/htlconfroom-list" element={<HtlConfgRoomList />} />
        <Route path="/htl/htl-adm/spawellness/htlsparoom-list" element={<HtlSpaRoomList />} />

        <Route path="/htl/bookings/reservation/htlresabout-list" element={<HtlResAboutList />} />
        <Route path="/htl/bookings/reservation/HtlResAboutDtlEdit/:rez_mid_id" element={<HtlResAboutDtlEdit />} />
     
        <Route path="/crm/users/user-list" element={<UsersList />} />
        <Route path="/crm/cust/cust-list" element={<CustList />} />
        <Route path="/crm/cust/cust-edit/:id_seq" element={<CustDtlEdit />} />
        <Route path="/crm/cust/cust-edit-web/:id_seq" element={<CustDtlEditWeb />} />

        <Route path="/crm/cust/cust-call-list" element={<CusCallList />} />
        <Route path="/crm/cust/cust-book-list" element={<CustomerBookList />} />

        <Route path="/crm/cust/cust-new-list-en" element={<NewCustListEn />} />
        <Route path="/crm/cust/cust-new-list-ar" element={<NewCustListAr />} />
        <Route path="/crm/cust/cust-new-list-de" element={<NewCustListDe />} />
        <Route path="/crm/cust/cust-new-list-ru" element={<NewCustListRu />} />

        <Route path="/crm/cust/cust-merge-list" element={<CustListMerge />} />
     
      </Route>
     

      <Route path="/" element={<AuthLayout/>}>
        <Route path='Sing-Up' element={<SingUp />} />  
        <Route path='Sing-In' element={<SingIn />} /> 
      </Route> 
    </Routes>
   </Router>
  
   
  );

  
}



export default Vari;